import type { DummyFoods } from './dummyFoods'

export const beef: DummyFoods = {
  Beef: {
    Fatty: {
      Cooked: ['Fatty beef (cooked)'],
      Raw: ['Fatty beef (raw)'],
    },
    'I want to be more specific': {
      'Bottom round': {
        Cooked: ['Bottom round (cooked)'],
        Raw: ['Bottom round (raw)'],
      },
      'Eye of round': {
        Cooked: ['Eye of round (cooked)'],
        Raw: ['Eye of round (raw)'],
      },
      Ribeye: {
        Cooked: ['Ribeye (cooked)'],
        Raw: ['Ribeye (raw)'],
      },
      'Sirloin tip': {
        Cooked: ['Sirloin tip (cooked)'],
        Raw: ['Sirloin tip (raw)'],
      },
      'Skirt steak': {
        Cooked: ['Skirt steak (cooked)'],
        Raw: ['Skirt steak (raw)'],
      },
      'Strip steak': {
        Cooked: ['Strip steak (cooked)'],
        Raw: ['Strip steak (raw)'],
      },
      'Top round': {
        Cooked: ['Top round (cooked)'],
        Raw: ['Top round (raw)'],
      },
    },
    Lean: {
      Cooked: ['Lean beef (cooked)'],
      Raw: ['Lean beef (raw)'],
    },
  },
}
